export default __webpack_public_path__ + "static/media/brokenDoll.27ade319.png";